import dayjs from 'dayjs'
import { usePathname } from 'next/navigation'

import 'dayjs/locale/ar'
import 'dayjs/locale/en'

const useFormatDate = () => {
    const pathname = usePathname()
    const localeFromPath = pathname.split('/')[1] || 'en';
    const formatDate = (date: string, format: string = 'ddd, DD MMM YYYY') => {
        if (localeFromPath) {
            dayjs.locale(localeFromPath)
        }
        return dayjs(date).format(format)
    }
    return { formatDate }
}

export default useFormatDate
